document.addEventListener('DOMContentLoaded', function() {
  const accordeons = document.querySelectorAll('[accordeon]');
  
  accordeons.forEach(function(accordeon) {
    const header = accordeon
    const content = accordeon.querySelector('[show]')
    
    if (!header || !content) return
    
    content.style.maxHeight = '0px'
    content.style.overflow = 'hidden'
    content.style.transition = 'max-height 0.3s ease-out'
    
    header.addEventListener('click', function() {
      if (content.style.maxHeight === '0px') {
        content.style.maxHeight = content.scrollHeight + 'px'
      } else {
        content.style.maxHeight = '0px'
      }
    });
  });
});